import { StaffService } from './../../../../core/human-resource/_services/staff.service';
// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// RxJS
import { Observable, Subject } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';
// Translate
import { TranslateService } from '@ngx-translate/core';
// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
// Auth
import { AuthNoticeService, AuthService, Login, UserLoaded, UserRequested } from '../../../../core/auth';
import { AuthLoginService } from './auth-login.service';
import { RolePermissionService, RolesModel } from 'src/app/core/role_permission';
import { JwtHelperService } from "@auth0/angular-jwt";

/**
 * ! Just example => Should be removed in development
 */
const DEMO_PARAMS = {
	EMAIL: 'superadmin@gmail.com',
	PASSWORD: '123'
};

@Component({
	selector: 'kt-login',
	templateUrl: './login.component.html',
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
	// Public params
	loginForm: FormGroup;
	loading = false;
	isLoggedIn$: Observable<boolean>;
	errors: any = [];

	private unsubscribe: Subject<any>;

	private returnUrl: any;

	// Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

	/**
	 * Component constructor
	 *
	 * @param router: Router
	 * @param auth: AuthService
	 * @param authNoticeService: AuthNoticeService
	 * @param translate: TranslateService
	 * @param store: Store<AppState>
	 * @param fb: FormBuilder
	 * @param cdr
	 * @param route
	 */
	constructor(
		private router: Router,
		private auth: AuthService,
		private authNoticeService: AuthNoticeService,
		private translate: TranslateService,
		private store: Store<AppState>,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private route: ActivatedRoute,
		private authloginservice: AuthLoginService,
		private rolePermissionService: RolePermissionService,
		private jwtHelperService: JwtHelperService,
		private staffService: StaffService,
	) {
		this.unsubscribe = new Subject();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.initLoginForm();

		// redirect back to the returnUrl before login
		this.route.queryParams.subscribe(params => {
			this.returnUrl = params.returnUrl || '/';
		});
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null);
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initLoginForm() {
		// demo message to show
		if (!this.authNoticeService.onNoticeChanged$.getValue()) {
			const initialNotice = `Use account
			<strong>${DEMO_PARAMS.EMAIL}</strong> and password
			<strong>${DEMO_PARAMS.PASSWORD}</strong> to continue.`;
			this.authNoticeService.setNotice(initialNotice, 'info');
		}

		this.loginForm = this.fb.group({
			email: [DEMO_PARAMS.EMAIL, Validators.compose([
				Validators.required,
				Validators.email,
				Validators.minLength(3),
				Validators.maxLength(320) // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
			])
			],
			password: [DEMO_PARAMS.PASSWORD, Validators.compose([
				Validators.required,
				Validators.minLength(3),
				Validators.maxLength(100)
			])
			]
		});
	}

	/**
	 * Form Submit
	 */

	login() {

		const authData = {
			username: 'superadmin@gmail.com',
			password: '123'
		}
		this.authloginservice.isLogin(authData).subscribe((res: any) => {
			console.log(res);

			localStorage.setItem('token', res['accessToken']);
			localStorage.setItem('userId', res['id']);
			const decodedToken = this.jwtHelperService.decodeToken(res['accessToken']);
			localStorage.setItem('sessionId', decodedToken.SessionID);


			//    this.jwtauth.setToken(res.accessToken);
			//   this.localstorage.set("CurrentRole",res.roles[0]);
			//   this.localstorage.set("CurrentUsername",res.username);
			//   this.localstorage.set("access_token",res);
			//   this.router.navigate(['/admin']);
			//  console.log(this.jwtauth.getSessionID());
			console.log('success');
			alert('Login Successfully');
			this.getDynamicMenuConfig(res['roles'][0]);
			this.templateLogin();
			this.getLoginUserById(res['id']);



		}, (err) => {
			console.log('Error While Login');
			alert('Wrong Credentials!!!');
			console.error(err);
		});
	}

	submit() {
		const controls = this.loginForm.controls;
		/** check form */
		if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading = true;
		this.login();

	}
	getDynamicMenuConfig(roleName) {
		// const roleName= localStorage.getItem('schoolRoleConfig');
		this.rolePermissionService.getAllPermissionsByRole(roleName).subscribe(res => {
			debugger;
			const data = res['data'];
			// const content = data['content'];
			localStorage.setItem('sideMenusConfig', JSON.stringify(	 data ));
			console.log(data);
		}, err => {

		})

	}


	getLoginUserById(id) {
		this.staffService.getStaffById(id).subscribe(res => {

			console.log(res)
		})

	}

	templateLogin() {
		debugger
		const controls = this.loginForm.controls;
		const authData = {
			email: controls.email.value,
			password: controls.password.value
		};
		this.auth
			.login(authData.email, authData.password)
			.pipe(
				tap(user => {
					if (user) {
						this.store.dispatch(new Login({ authToken: user.accessToken }));
						this.router.navigateByUrl(this.returnUrl); // Main page
					} else {
						this.authNoticeService.setNotice(this.translate.instant('AUTH.VALIDATION.INVALID_LOGIN'), 'danger');
					}
				}),
				takeUntil(this.unsubscribe),
				finalize(() => {
					this.loading = false;
					this.cdr.markForCheck();
				})
			)
			.subscribe();
	}
	/**
	 * Checking control validation
	 *
	 * @param controlName: string => Equals to formControlName
	 * @param validationType: string => Equals to valitors name
	 */
	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}
}
